import { render, staticRenderFns } from "./ExtinguisherDetails.vue?vue&type=template&id=6ab10eaa&scoped=true"
import script from "./ExtinguisherDetails.vue?vue&type=script&lang=js"
export * from "./ExtinguisherDetails.vue?vue&type=script&lang=js"
import style0 from "./ExtinguisherDetails.vue?vue&type=style&index=0&id=6ab10eaa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ab10eaa",
  null
  
)

export default component.exports